import { Analytics } from "@vercel/analytics/next";
import { state } from "@wb/ui/analytics/state";
import { vercel } from "@wb/ui/analytics/vercel";
import { type FC, useEffect } from "react";

export const VercelAnalytics: FC = () => {
  useEffect(() => {
    state.instances.push(vercel);
  }, []);

  return <Analytics />;
};
